import React, { Component } from 'react';
import i18n from 'i18n-react';

import { storageKeys } from 'settings';
import { APIHandler, ShowcaseCollection, DataHandler, ContentHeader, BackImage, StorageHandler } from 'C4';
import PropTypes from 'prop-types';

export default class ShowcaseCollectionView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stands: {},
      language: 'en',
    };
  }

  componentWillMount() {
    this.getStandsAndFloor();
  }

  async getStandsAndFloor() {
    let appId = await DataHandler.matchAppId();
    const lang = await StorageHandler.load(storageKeys.lang);

    // Mobile from url params
    const params = new URLSearchParams(window.location.search);
    const exhbitions = await APIHandler.getExhibitionStands(appId);
    if (params.get('mobile')) {
      this.setState({ language: params.get('language')});
      appId = params.get('appId');
      exhbitions.forEach((stand) => {
        this.getItemsPerCategory(stand.tiles, stand.title, params.get('language'));
      });
    } else {
      this.setState({ language: lang.langFile });
      exhbitions.forEach((stand) => {
        this.getItemsPerCategory(stand.tiles, stand.title, lang.langFile);
      });
    }
  }

  async getItemsPerCategory(stands, category, lang) {
    let ids = '';
    stands.forEach((stand) => {
      ids += `&ids[]=${stand.company_id}`;
    });

    const items = this.state.stands;
    const allStands = await APIHandler.getStands(ids, lang);
    items[category] = allStands.items;
    this.setState({ stands: items });

    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = 'guest';
      if (userObj && userObj.response) {
        ({ email } = userObj.response);
      }
      APIHandler.trackSearch(ids, email).then((res) => {
      });
    });

  }

  render() {
    const { stands, language } = this.state;
    const params = new URLSearchParams(window.location.search);
    if (stands.length === 0) {
      return <div />;
    }

    return (
      <div className="showcaseCollectionViewContainer">
        <BackImage />
        <div className="showcaseContainer">
          <ContentHeader header={i18n.translate('general.showcase')} icon="" line={false} />
          <div className="showcaseCountriesGrid">
            {Object.entries(stands).map(([key, stand]) => (
              <ShowcaseCollection stands={stand} category={key} key={key} language={language} />
            ))}
            <style>{'\
            .fancybox-slide--iframe .fancybox-content { max-width  : 960px; margin: 0; }'}
            </style>
            {params.get('header') &&
            <style>{'\
          .header { display: none !important; } .showcaseContainer { margin-top: 3rem !important; } .cookieConsent { display: none !important; }'}
            </style>}
          </div>
        </div>
      </div>
    );
  }
}

ShowcaseCollectionView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape().isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
};

ShowcaseCollectionView.defaultProps = {
  // headerSubtitle: '',
};
